import { data } from '../../svg/ExpandMore/data';
import { makeIcon } from '../makeIcon';

export const ExpandMore = makeIcon(data, 'expand_more', 'ExpandMore');

export default ExpandMore;
